import React from 'react';
import PropTypes from 'prop-types';
import ADGMAccordion from 'aurora-components/ADGMAccordion/ADGMAccordion';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/styles/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import Button from '@material-ui/core/Button';
import messages from 'translations/allMessages';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { ADGMImage } from 'aurora-components';
import styles from './styles';

const propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  documents: PropTypes.array.isRequired,
  handleDownloadDocument: PropTypes.func.isRequired,
  applicationId: PropTypes.string.isRequired,
  applicationType: PropTypes.string.isRequired,
  showDocumentType: PropTypes.bool,
  intl: PropTypes.object.isRequired,
  companyId: PropTypes.string.isRequired,
};
const defaultValues = {
  showDocumentType: false,
};
const CurrentContractDocuments = ({
  classes,
  title,
  documents,
  handleDownloadDocument,
  applicationId,
  applicationType,
  showDocumentType,
  intl,
  companyId,
}) => {
  const handleFileDownload = doc => {
    const payload = {
      ...(applicationId && { applicationId }),
      ...(applicationType && { applicationType }),
      documentType: doc.type,
      subType: doc.subType,
      companyId,
      fileName: showDocumentType
        ? messages[doc.type]?.id
          ? intl.formatMessage(messages[doc.type])
          : doc.fileName
        : doc.fileName,
    };
    handleDownloadDocument && handleDownloadDocument(payload);
  };

  return (
    documents?.length > 0 && (
      <ADGMAccordion title={keyEmptyCheck(title)}>
        {documents.map(file => (
          <div className={classes.documentContainer} key={file.id}>
            <div className={classes.fileIconHolder}>
              <ADGMImage name='appendixDocument.svg' alt='pdf' />
              <Typography className={classes.fileName}>
                {showDocumentType ? keyEmptyCheck(file.type) : file.fileName}
              </Typography>
            </div>
            <Button className={classes.viewFile} onClick={() => handleFileDownload(file)}>
              <FormattedMessage {...messages.view} />
            </Button>
          </div>
        ))}
      </ADGMAccordion>
    )
  );
};
CurrentContractDocuments.propTypes = propTypes;
CurrentContractDocuments.defaultProps = defaultValues;
export default withStyles(styles)(injectIntl(CurrentContractDocuments));
